import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { fragments } from './quote-data.model';

export const getQuoteOptionByIdQuery: DocumentNode = gql`
  query quote($id: Int!) {
    quoteOption(id: $id) {
      id
      description
      uuid
      quoteData {
        ...QuoteDataFields
      }
    }
  }
  ${fragments.quoteData}
`;

export const getQuoteOptionByUuidQuery: DocumentNode = gql`
  query getQuoteOptionByUuidQuery($uuid: ID!) {
    getOneByUuidDistributor(uuid: $uuid) {
      id
      description
      uuid
      # What this option was last priced at, and whether an edit since has
      # overtaken it. Asked for here rather than in a query of their own: the
      # resolver reads the whole row, and that row carries the drawing, which
      # runs to megabytes on a large floor.
      totalSelling
      backsheetStale
      quoteData {
        ...QuoteDataFields
      }
    }
  }
  ${fragments.quoteData}
`;

export const createQuoteQuery: DocumentNode = gql`
  mutation createQuote($quoteInput: QuoteInput, $quoteDataInput: QuoteDataInput) {
    createQuote(quoteInput: $quoteInput, quoteDataInput: $quoteDataInput) {
      quote {
        id
        description
      }
      quoteRevision {
        id
        description
      }
      quoteOption {
        id
        description
        uuid
        quoteData {
          ...QuoteDataFields
        }
      }
    }
  }
  ${fragments.quoteData}
`;

/**
 * The portal's own pair.
 *
 * `createQuote` and `updateQuoteOption` take wide inputs — the distributor the
 * quote belongs to, its type, totalSelling, targetGp — which a portal login
 * must not be able to name, so the `distributor` role no longer holds the
 * scopes for either. These carry the quote data and nothing else; ownership,
 * type and margin are the server's to decide.
 */
export const createPortalQuoteQuery: DocumentNode = gql`
  mutation createPortalQuote($quoteData: QuoteDataInput!) {
    createPortalQuote(quoteData: $quoteData) {
      quote {
        id
        description
      }
      quoteRevision {
        id
        description
      }
      quoteOption {
        id
        description
        uuid
        quoteData {
          ...QuoteDataFields
        }
      }
    }
  }
  ${fragments.quoteData}
`;

export const updatePortalQuoteOptionQuery: DocumentNode = gql`
  mutation updatePortalQuoteOption($id: Int!, $quoteData: QuoteDataInput!) {
    updatePortalQuoteOption(id: $id, quoteData: $quoteData) {
      id
      description
    }
  }
`;

export const createQuoteRevisionQuery: DocumentNode = gql`
  mutation createQuoteRevision($revision: QuoteRevisionInput) {
    createQuoteRevision(quoteRevisionInput: $revision) {
      id
      description
    }
  }
`;

export const createQuoteOptionQuery: DocumentNode = gql`
  mutation createQuoteOption($option: QuoteOptionInput) {
    createQuoteOption(quoteOptionInput: $option) {
      id
      description
    }
  }
`;

export const updateQuoteOptionQuery: DocumentNode = gql`
  mutation updateQuoteOption($option: QuoteOptionInput) {
    updateQuoteOption(quoteOptionInput: $option) {
      id
      description
    }
  }
`;

export const getHeavyLoadTypeDefault: DocumentNode = gql`
  query getHeavyLoadTypeDefault {
    loadTypeDefault(description: "Heavy") {
      id
      liveLoad
      centres
      deckingSection {
        id
      }
    }
  }
`;
